import React from "react";
import AddIcon from "@material-ui/icons/Add";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import "./styles.scss";

const AddPerson = () => {
  
  return (
    <div style={{ margin: "21px 20px", textAlign: "right" }}>
      <div>
        <Link to="/info-member">
          <Button
            variant="contained"
            component="span"
            className="button-add-person"
          >
            <AddIcon />
          </Button>
        </Link>
      </div>
    </div>
  );
};
export { AddPerson };
